
import React from "react";
import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import Button from "../Button";

import {FaCircleCheck} from "react-icons/fa6";

const SuccessModal=(props)=>{

    return <ModalWrapper  onClose={()=>{}}  animation="slideDown" contentContainerClassName="w-11/12 flex flex-col justify-center items-center flex-col md:8/12 lg:w-4/12 p-5 rounded-xl">
        <FaCircleCheck className="text-5xl text-green-500 mb-5"/>
        <h1 className="text-2xl  font-bold text-green-500 text-center ">{props.title}</h1>
        <p className="text-gray-700 text-center mb-3 ">{props.message}</p>
        <div className={`w-full mt-2 grid gap-2  grid-cols-${(props.showConfirmButton && props.showCancelButton) ? 2:1}`}>
            {props.showConfirmButton && <Button onClick={props.onConfirm} rounded="rounded-lg" theme={props.confirmButtonTheme || "light"} className="text-sm">{props?.confirmButtonText||'باشه'}</Button> }
             {props.showCancelButton && <Button onClick={()=>{
                 props.onCancel();
                 Reoverlay.hideModal();
             }}  rounded="rounded-lg" theme={props.cancelButtonTheme || "green"} className="text-sm">{props?.cancelButtonText||'بستن'}</Button> }
        </div>


    </ModalWrapper>
}
export default SuccessModal;